import { shape, string } from 'prop-types';

export const errorPropType = shape({ type: string.isRequired });
